var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeNeutral = function SvgYoutubeNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.624 6.913a2.23 2.23 0 0 0-1.591-1.547C17.629 5 12 5 12 5s-5.629 0-7.033.366a2.23 2.23 0 0 0-1.59 1.547C3 8.278 3 12 3 12s0 3.722.376 5.087a2.23 2.23 0 0 0 1.591 1.547C6.371 19 12 19 12 19s5.629 0 7.033-.366a2.22 2.22 0 0 0 1.59-1.547C21 15.722 21 12 21 12s0-3.722-.376-5.087M10.2 14.273V9.727c0-.337.375-.547.675-.38l4.05 2.274c.3.168.3.59 0 .758l-4.05 2.273c-.3.169-.675-.042-.675-.379"
  })));
};
export { SvgYoutubeNeutral as ReactComponent };